import { render } from "./DescriptionField.vue?vue&type=template&id=42829fb3&scoped=true"
import script from "./DescriptionField.vue?vue&type=script&lang=js"
export * from "./DescriptionField.vue?vue&type=script&lang=js"

import "./DescriptionField.vue?vue&type=style&index=0&id=42829fb3&lang=scss&scoped=true"
import "./DescriptionField.vue?vue&type=style&index=1&id=42829fb3&lang=scss"
import "./DescriptionField.vue?vue&type=style&index=2&id=42829fb3&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42829fb3"]])

export default __exports__